export default __webpack_public_path__ + "static/media/logo-empty-box.e86396e6.svg";